import {
  GetOrganizationSummariesResponseBodyType,
  OrgShopIdDto,
} from "@intelligems/ig-types";
import { getAdminOrganizationSummaryById } from "@src/api/organization-summaries/admin-get-organization-summary-by-id";
import { organizationsKeys } from "@src/api/queryKeys";
import { QueryClient } from "@tanstack/react-query";

export const invalidateOrganizationSummary = async (
  queryClient: QueryClient,
  orgs: OrgShopIdDto[]
) => {
  await Promise.all(
    orgs.map(async (org) => {
      const resp = await getAdminOrganizationSummaryById(org.id);
      queryClient.setQueryData(
        organizationsKeys.orgSummaries,
        (prev: GetOrganizationSummariesResponseBodyType | undefined) => {
          if (!prev) return prev; // No previous data, return as-is.

          const updatedOrgs = [...prev.orgs];

          const index = prev.orgs.findIndex((o) => o.id === org.id);
          if (index === -1) {
            return;
          }

          updatedOrgs[index] = resp.org;
          return {
            ...prev,
            orgs: updatedOrgs,
          };
        }
      );
    })
  );
};
